<template>
    <div class="center-box singCar-left" style="width: 400px">
        <title1 title="车辆信息" :isBg="false" fontSize="32" />
            <div
                v-for="(item, i) in target1"
                :key="'target1' + i"
                class="flex align-center target4">
                <img class="img" :src="item.icon" />
                <div class="flex flex-direction">
                    <div class="label">{{ item.label}}</div>
                    <div class="num text flex align-center" :style="{'color': item.color}">{{ item.number }}</div>
                </div>
            </div>
    </div>
</template>

<script>
import { dataInterface } from "@/api/dataInterfaceApi";
import title1 from '@/views/exposition/components/title1'
export default {
    components: {
        title1
    },
    data() {
        return {
            target1: [
                {
                    icon: require('@/assets/images/exposition/chd-9.png'),
                    number: '',
                    label: '车牌号',
                    color: '#36FBFB'
                },
                {
                    icon: require('@/assets/images/exposition/car-2.png'),
                    number: '',
                    label: '车辆VIN码',
                    color: '#43FFB9'
                },
                {
                    icon: require('@/assets/images/exposition/car-3.png'),
                    number: '',
                    label: '运营商',
                    color: '#FFFFFF'
                },
                {
                    icon: require('@/assets/images/exposition/car-4.png'),
                    number: '',
                    label: '品牌型号',
                    color: '#179DFF'
                },
            ],
        }
    },
    mounted() {
      // 车辆信息
      this.getCarInfoList()
    },
    methods: {
      // 获取车辆信息
		getCarInfoList() {
			let params = {
		      "enCode": "per_vehicle-VIN码-车牌号-车型-所属运营商",
		      "@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ? localStorage.getItem("newVehicleNum") : 'LDP31B967MG929008'
		    }
			dataInterface.dataFaceApi(params).then((res) => {
        console.log(res, '车辆信息')
        this.target1[0].number = res[0].license_plate || ''
        this.target1[1].number = res[0].vehicle_vin   || ''
        this.target1[2].number = res[0].gcl_operating_company || ''
        this.target1[3].number = res[0].vehicle_model || ''
 || ''
				// this.carDataList = res[0] ? res[0] : {}
			}).catch((err) => {
			    console.log(err);
			  });
		},
    }
}
</script>

<style lang="scss" scoped>
@import '../scss/chd-com.scss';
.singCar-left {
    position: absolute;
    left: 0;
}
</style>